import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

type Item = {
  value: string;
  label: string;
};

type DateRangeQueries = {
  ti?: string;
  uti?: string;
  ts?: number;
  uts?: number;
};
export type QueryParamsHook = {
  selectedSegments?: Item[];
  contentId?: string;
  dateRangeQueries: DateRangeQueries;
};
export const useQueryParams = ({
  selectedSegments,
  contentId,
  dateRangeQueries,
}: QueryParamsHook) => {
  const [searchParams] = useSearchParams();
  const hasSegments = selectedSegments && selectedSegments?.length > 0;
  const dataEntries = useMemo(() => {
    if (hasSegments) {
      return selectedSegments || [];
    }
    return [dateRangeQueries];
  }, [hasSegments, selectedSegments, dateRangeQueries]);

  const queryParams = useCallback(
    (entry: Item | DateRangeQueries) =>
      hasSegments
        ? {
            contentId,
            segmentId: (entry as Item).value,
            f: searchParams.get('f'),
            ...dateRangeQueries,
          }
        : {
            contentId,
            f: searchParams.get('f'),
            ...(entry as DateRangeQueries),
          },
    [dateRangeQueries, contentId, hasSegments],
  );
  return { queryParams, dataEntries };
};
